import React from "react";

// SNS Infotech brand mark — a faceted security shield carrying a bold,
// angular circuit-style "S" monogram. Blue→cyan gradient for tech/cyber,
// a single gold node for the private-equity / holdings heritage.
export const LogoMark = ({ size = 44 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="SNS Infotech logo"
  >
    <defs>
      <linearGradient id="snsShield" x1="12" y1="6" x2="52" y2="60" gradientUnits="userSpaceOnUse">
        <stop stopColor="#1E90FF" />
        <stop offset="0.55" stopColor="#0B5ED7" />
        <stop offset="1" stopColor="#062B66" />
      </linearGradient>
      <linearGradient id="snsEdge" x1="10" y1="4" x2="54" y2="62" gradientUnits="userSpaceOnUse">
        <stop stopColor="#7FD4FF" />
        <stop offset="0.5" stopColor="#1E90FF" />
        <stop offset="1" stopColor="#00E5FF" />
      </linearGradient>
      <linearGradient id="snsS" x1="20" y1="18" x2="44" y2="48" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFFFFF" />
        <stop offset="1" stopColor="#B9F3FF" />
      </linearGradient>
      <filter id="snsGlow" x="-30%" y="-30%" width="160%" height="160%">
        <feGaussianBlur stdDeviation="1.6" result="b" />
        <feMerge>
          <feMergeNode in="b" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>

    {/* Faceted shield body */}
    <path
      d="M32 3.5L55 11.5V30.5C55 44.6 45.4 55.2 32 60.5C18.6 55.2 9 44.6 9 30.5V11.5L32 3.5Z"
      fill="url(#snsShield)"
    />
    {/* Facet highlight (left panel) */}
    <path
      d="M32 3.5V60.5C18.6 55.2 9 44.6 9 30.5V11.5L32 3.5Z"
      fill="#FFFFFF"
      fillOpacity="0.07"
    />
    {/* Shield edge */}
    <path
      d="M32 3.5L55 11.5V30.5C55 44.6 45.4 55.2 32 60.5C18.6 55.2 9 44.6 9 30.5V11.5L32 3.5Z"
      stroke="url(#snsEdge)"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />

    {/* Circuit traces */}
    <g stroke="#00E5FF" strokeOpacity="0.55" strokeWidth="1.2" strokeLinecap="round">
      <path d="M46 20.5h4.5" />
      <path d="M13.5 43.5h4.5" />
      <path d="M32 54v3.5" />
    </g>
    <circle cx="51.5" cy="20.5" r="1.4" fill="#00E5FF" />
    <circle cx="12.5" cy="43.5" r="1.4" fill="#00E5FF" />

    {/* Angular circuit "S" monogram */}
    <g filter="url(#snsGlow)">
      <path
        d="M43 20.5H25.5C23.6 20.5 22 22.1 22 24V28.5C22 30.4 23.6 32 25.5 32H38.5C40.4 32 42 33.6 42 35.5V40C42 41.9 40.4 43.5 38.5 43.5H21"
        stroke="url(#snsS)"
        strokeWidth="5.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </g>

    {/* Gold node — holdings / private equity */}
    <circle cx="45.5" cy="20.5" r="3.4" fill="#0A0A0C" />
    <circle cx="45.5" cy="20.5" r="2.3" fill="#D4AF37" />
  </svg>
);

export const Logo = ({ size = 44, withText = true, className = "" }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <LogoMark size={size} />

      {withText && (
        <div className="leading-none select-none">
          <div className="flex items-baseline gap-1.5">
            <span className="font-display font-extrabold text-[22px] tracking-[-0.02em] text-white">
              SNS
            </span>
            <span className="font-display font-semibold text-[13px] tracking-[0.12em] text-[#7FD4FF] uppercase">
              Infotech
            </span>
          </div>
          <div className="flex items-center gap-2 mt-1.5">
            <span className="h-px w-5 bg-gradient-to-r from-[#D4AF37] to-transparent" />
            <span className="font-mono text-[8.5px] tracking-[0.32em] text-zinc-400 uppercase">
              International Holdings
            </span>
          </div>
        </div>
      )}
    </div>
  );
};
